import { render, staticRenderFns } from "./ConnectionLostSticker.vue?vue&type=template&id=2fb79ac8&scoped=true&"
import script from "./ConnectionLostSticker.vue?vue&type=script&lang=js&"
export * from "./ConnectionLostSticker.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionLostSticker.vue?vue&type=style&index=0&id=2fb79ac8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb79ac8",
  null
  
)

export default component.exports